import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class StatusController extends Controller {
  @tracked serverStatuses = [];
}
